export default function Pricing() {
  return <h2>Pricing Page</h2>;
}
